import React from "react";
import Filter from "./Section/Filter";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import { useSetState } from "../../../utils/hooks";
import Stats from "./Section/Stats";
import CheckArea from "./Section/CheckArea";
import { InventoryTable } from "./Section/inventory-table";
import { useInventoriesCount } from "../../../api/inventory/use-inventories-count";

function InventoryPage() {
  const [filter, dispatchFilter] = useSetState();
  const [sort, dispatchSort] = useSetState();
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("ref");
  const { data } = useInventoriesCount();

  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onSubmitFilter = () => {
    if (filter !== undefined) {
      if (searchBy === "ref") {
        delete filter["name"];
        setSelectedFilter(filter);
      }
      if (searchBy === "name") {
        delete filter["ref"];
        setSelectedFilter(filter);
      }
    }
  };

  const onResetFilter = () => {
    setSelectedFilter({});
  };

  return (
    <>
      <div>
        <TitlePage title="재고관리" />
        <Stats data={data?.data} />
        <div className="my-4 flex justify-end items-center gap-4">
          <span className="text-[#707070]">업데이트 2023.06.01 23:59:59</span>
          <button className="border border-[#aaaaaa] py-[2px] w-[5rem] text-black rounded-[4px]">
            새로고침
          </button>
        </div>
        <Filter
          onSubmitFilter={onSubmitFilter}
          onFilter={dispatchFilter}
          onResetFilter={onResetFilter}
          onChangeSearchBy={onChangeSearchBy}
          searchBy={searchBy}
        />
        <CheckArea
          onSortBy={(e) => dispatchSort({ orderBy: e.target.value })}
        />
        <InventoryTable
          onSort={dispatchSort}
          sort={sort}
          filter={selectedFilter}
          onClose={onResetFilter}
        />
      </div>
    </>
  );
}

export default InventoryPage;
